import { rgba } from 'polished';
import styled from 'styled-components';

import { HeaderButtonContainerProps } from './types';

export const ButtonContainer = styled.button<HeaderButtonContainerProps>`
  display: flex;
  flex-direction: column;
  width: 84px;
  padding: 1rem;
  height: 80px;
  align-items: center;
  justify-content: center;
  border: none;
  transition: 0.3s;
  background-color: ${({ $isSelected }: HeaderButtonContainerProps) =>
    $isSelected ? rgba(Styles.color.grey.one, 0.2) : 'transparent'};

  img,
  div {
    filter: grayscale(100%) brightness(100) invert();
  }

  ${Styles.desktop`
    border-radius: ${({ $displayRoundBorders }: HeaderButtonContainerProps) =>
      $displayRoundBorders ? Styles.borderRadius : '0'};

    &:hover {
      height: ${({ $displayRoundBorders }: HeaderButtonContainerProps) =>
        $displayRoundBorders ? '80px' : '84px'};
      background-color: ${({ $displayRoundBorders }: HeaderButtonContainerProps) =>
        $displayRoundBorders ? '' : rgba(Styles.color.grey.one, 0.4)};
    }
    cursor: pointer;
  `}
`;

export const Label = styled.span`
  margin-top: 4px;
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.normal};
  font-size: 0.875rem;
  line-height: 1.05rem;
  letter-spacing: 0;
  text-align: center;
  color: ${Styles.color.white};
`;
